/*
  Platform admin: trial funnel. Merged FIRST into TRANSLATION_MAPS in ./index.js,
  so an existing translation of a common word (Email, Paid…) still wins. Keys are
  the English source.
*/

const ru = {
  "Trial: where clients stop": "Пробный период: где клиенты останавливаются",
  "Accounts registered in the period, without team members and operator accounts. For each step: how many accounts reached it, how many did it within 24 hours of sign-up, and the median time from the previous step.": "Аккаунты, зарегистрированные за период, без участников команд и аккаунтов операторов. Для каждого шага: сколько аккаунтов его прошли, сколько — в первые 24 часа после регистрации, и медианное время от предыдущего шага.",
  "Period: 7 days": "Период: 7 дней",
  "Period: 30 days": "Период: 30 дней",
  "Period: 90 days": "Период: 90 дней",
  "Step": "Шаг",
  "Accounts": "Аккаунты",
  "Of sign-ups": "От регистраций",
  "Within 24 hours": "За 24 часа",
  "Median time from previous step": "Медиана от предыдущего шага",
  "Registration": "Регистрация",
  "Email confirmed": "Адрес подтверждён",
  "Card added": "Карта добавлена",
  "First campaign": "Первая кампания",
  "Stream with an offer": "Поток с оффером",
  "First click": "Первый клик",
  "First lead (forms only)": "Первый лид (только формы)",
  "First conversion": "Первая конверсия",
  "Paid": "Оплачено",
  "In trial": "Пробный период",
  "Stopped: no payment": "Остановлен: нет оплаты",
  "No card": "Нет карты",
  "Granted by operator": "Выдан оператором",
  "First conversion within 24 hours of sign-up": "Первая конверсия в первые 24 часа после регистрации",
  "Recent accounts": "Последние аккаунты",
  "Email": "Эл. почта",
  "Registered": "Дата регистрации",
  "Stopped at": "Остановился на шаге",
  "Result": "Итог",
  "All steps done": "Все шаги пройдены",
  "No accounts in this period.": "За этот период аккаунтов нет.",
  "Card time is estimated from the trial end date. Email confirmation time is recorded from this release on.": "Время добавления карты рассчитано по дате окончания пробного периода. Время подтверждения адреса записывается начиная с этой версии.",
  "Failed to load the trial funnel": "Не удалось загрузить воронку пробного периода",
  "{n} min": "{n} мин",
  "{n} h": "{n} ч",
  "{n} d": "{n} дн.",
  "{n} of {total} accounts": "{n} из {total} аккаунтов",
  "Loading…": "Загрузка…",
};

const es = {
  "Trial: where clients stop": "Prueba: dónde se detienen los clientes",
  "Accounts registered in the period, without team members and operator accounts. For each step: how many accounts reached it, how many did it within 24 hours of sign-up, and the median time from the previous step.": "Cuentas registradas en el período, sin miembros de equipos ni cuentas de operadores. Para cada paso: cuántas cuentas lo alcanzaron, cuántas en las primeras 24 horas tras el registro y la mediana de tiempo desde el paso anterior.",
  "Period: 7 days": "Período: 7 días",
  "Period: 30 days": "Período: 30 días",
  "Period: 90 days": "Período: 90 días",
  "Step": "Paso",
  "Accounts": "Cuentas",
  "Of sign-ups": "De los registros",
  "Within 24 hours": "En 24 horas",
  "Median time from previous step": "Mediana desde el paso anterior",
  "Registration": "Registro",
  "Email confirmed": "Correo confirmado",
  "Card added": "Tarjeta añadida",
  "First campaign": "Primera campaña",
  "Stream with an offer": "Flujo con oferta",
  "First click": "Primer clic",
  "First lead (forms only)": "Primer lead (solo formularios)",
  "First conversion": "Primera conversión",
  "Paid": "Pagado",
  "In trial": "En prueba",
  "Stopped: no payment": "Detenido: sin pago",
  "No card": "Sin tarjeta",
  "Granted by operator": "Otorgado por el operador",
  "First conversion within 24 hours of sign-up": "Primera conversión en las primeras 24 horas tras el registro",
  "Recent accounts": "Cuentas recientes",
  "Email": "Correo",
  "Registered": "Fecha de registro",
  "Stopped at": "Se detuvo en",
  "Result": "Resultado",
  "All steps done": "Todos los pasos completados",
  "No accounts in this period.": "No hay cuentas en este período.",
  "Card time is estimated from the trial end date. Email confirmation time is recorded from this release on.": "La hora de la tarjeta se estima a partir del fin de la prueba. La hora de confirmación del correo se registra desde esta versión.",
  "Failed to load the trial funnel": "No se pudo cargar el embudo de prueba",
  "{n} min": "{n} min",
  "{n} h": "{n} h",
  "{n} d": "{n} d",
  "{n} of {total} accounts": "{n} de {total} cuentas",
  "Loading…": "Cargando…",
};

const pt = {
  "Trial: where clients stop": "Teste: onde os clientes param",
  "Accounts registered in the period, without team members and operator accounts. For each step: how many accounts reached it, how many did it within 24 hours of sign-up, and the median time from the previous step.": "Contas registradas no período, sem membros de equipes e contas de operadores. Para cada etapa: quantas contas chegaram a ela, quantas nas primeiras 24 horas após o cadastro e a mediana de tempo desde a etapa anterior.",
  "Period: 7 days": "Período: 7 dias",
  "Period: 30 days": "Período: 30 dias",
  "Period: 90 days": "Período: 90 dias",
  "Step": "Etapa",
  "Accounts": "Contas",
  "Of sign-ups": "Dos cadastros",
  "Within 24 hours": "Em 24 horas",
  "Median time from previous step": "Mediana desde a etapa anterior",
  "Registration": "Cadastro",
  "Email confirmed": "E-mail confirmado",
  "Card added": "Cartão adicionado",
  "First campaign": "Primeira campanha",
  "Stream with an offer": "Fluxo com oferta",
  "First click": "Primeiro clique",
  "First lead (forms only)": "Primeiro lead (só formulários)",
  "First conversion": "Primeira conversão",
  "Paid": "Pago",
  "In trial": "Em teste",
  "Stopped: no payment": "Parado: sem pagamento",
  "No card": "Sem cartão",
  "Granted by operator": "Concedido pelo operador",
  "First conversion within 24 hours of sign-up": "Primeira conversão nas primeiras 24 horas após o cadastro",
  "Recent accounts": "Contas recentes",
  "Email": "E-mail",
  "Registered": "Data de cadastro",
  "Stopped at": "Parou em",
  "Result": "Resultado",
  "All steps done": "Todas as etapas concluídas",
  "No accounts in this period.": "Nenhuma conta neste período.",
  "Card time is estimated from the trial end date. Email confirmation time is recorded from this release on.": "A hora do cartão é estimada pela data de fim do teste. A hora de confirmação do e-mail é registrada a partir desta versão.",
  "Failed to load the trial funnel": "Não foi possível carregar o funil de teste",
  "{n} min": "{n} min",
  "{n} h": "{n} h",
  "{n} d": "{n} d",
  "{n} of {total} accounts": "{n} de {total} contas",
  "Loading…": "Carregando…",
};

const de = {
  "Trial: where clients stop": "Testphase: wo Kunden stehen bleiben",
  "Accounts registered in the period, without team members and operator accounts. For each step: how many accounts reached it, how many did it within 24 hours of sign-up, and the median time from the previous step.": "Im Zeitraum registrierte Konten, ohne Teammitglieder und Betreiberkonten. Für jeden Schritt: wie viele Konten ihn erreicht haben, wie viele innerhalb von 24 Stunden nach der Registrierung, und die mittlere Zeit (Median) seit dem vorherigen Schritt.",
  "Period: 7 days": "Zeitraum: 7 Tage",
  "Period: 30 days": "Zeitraum: 30 Tage",
  "Period: 90 days": "Zeitraum: 90 Tage",
  "Step": "Schritt",
  "Accounts": "Konten",
  "Of sign-ups": "Von Registrierungen",
  "Within 24 hours": "Innerhalb 24 Std.",
  "Median time from previous step": "Median seit vorherigem Schritt",
  "Registration": "Registrierung",
  "Email confirmed": "E-Mail bestätigt",
  "Card added": "Karte hinterlegt",
  "First campaign": "Erste Kampagne",
  "Stream with an offer": "Stream mit Angebot",
  "First click": "Erster Klick",
  "First lead (forms only)": "Erster Lead (nur Formulare)",
  "First conversion": "Erste Conversion",
  "Paid": "Bezahlt",
  "In trial": "In Testphase",
  "Stopped: no payment": "Gestoppt: keine Zahlung",
  "No card": "Keine Karte",
  "Granted by operator": "Vom Betreiber vergeben",
  "First conversion within 24 hours of sign-up": "Erste Conversion innerhalb von 24 Stunden nach der Registrierung",
  "Recent accounts": "Neueste Konten",
  "Email": "E-Mail",
  "Registered": "Registriert am",
  "Stopped at": "Stehen geblieben bei",
  "Result": "Ergebnis",
  "All steps done": "Alle Schritte erledigt",
  "No accounts in this period.": "Keine Konten in diesem Zeitraum.",
  "Card time is estimated from the trial end date. Email confirmation time is recorded from this release on.": "Der Zeitpunkt der Karte wird aus dem Ende der Testphase geschätzt. Der Zeitpunkt der E-Mail-Bestätigung wird ab dieser Version gespeichert.",
  "Failed to load the trial funnel": "Trichter der Testphase konnte nicht geladen werden",
  "{n} min": "{n} Min.",
  "{n} h": "{n} Std.",
  "{n} d": "{n} T.",
  "{n} of {total} accounts": "{n} von {total} Konten",
  "Loading…": "Wird geladen…",
};

const fr = {
  "Trial: where clients stop": "Essai : où les clients s’arrêtent",
  "Accounts registered in the period, without team members and operator accounts. For each step: how many accounts reached it, how many did it within 24 hours of sign-up, and the median time from the previous step.": "Comptes inscrits sur la période, hors membres d’équipe et comptes opérateurs. Pour chaque étape : combien de comptes l’ont atteinte, combien dans les 24 heures suivant l’inscription, et le temps médian depuis l’étape précédente.",
  "Period: 7 days": "Période : 7 jours",
  "Period: 30 days": "Période : 30 jours",
  "Period: 90 days": "Période : 90 jours",
  "Step": "Étape",
  "Accounts": "Comptes",
  "Of sign-ups": "Des inscriptions",
  "Within 24 hours": "En 24 heures",
  "Median time from previous step": "Médiane depuis l’étape précédente",
  "Registration": "Inscription",
  "Email confirmed": "E-mail confirmé",
  "Card added": "Carte ajoutée",
  "First campaign": "Première campagne",
  "Stream with an offer": "Flux avec une offre",
  "First click": "Premier clic",
  "First lead (forms only)": "Premier lead (formulaires seulement)",
  "First conversion": "Première conversion",
  "Paid": "Payé",
  "In trial": "En essai",
  "Stopped: no payment": "Arrêté : pas de paiement",
  "No card": "Pas de carte",
  "Granted by operator": "Accordé par l’opérateur",
  "First conversion within 24 hours of sign-up": "Première conversion dans les 24 heures suivant l’inscription",
  "Recent accounts": "Comptes récents",
  "Email": "E-mail",
  "Registered": "Inscrit le",
  "Stopped at": "Arrêté à",
  "Result": "Résultat",
  "All steps done": "Toutes les étapes faites",
  "No accounts in this period.": "Aucun compte sur cette période.",
  "Card time is estimated from the trial end date. Email confirmation time is recorded from this release on.": "L’heure de la carte est estimée à partir de la fin de l’essai. L’heure de confirmation de l’e-mail est enregistrée à partir de cette version.",
  "Failed to load the trial funnel": "Impossible de charger l’entonnoir d’essai",
  "{n} min": "{n} min",
  "{n} h": "{n} h",
  "{n} d": "{n} j",
  "{n} of {total} accounts": "{n} sur {total} comptes",
  "Loading…": "Chargement…",
};

const it = {
  "Trial: where clients stop": "Prova: dove si fermano i clienti",
  "Accounts registered in the period, without team members and operator accounts. For each step: how many accounts reached it, how many did it within 24 hours of sign-up, and the median time from the previous step.": "Account registrati nel periodo, esclusi i membri dei team e gli account operatore. Per ogni passo: quanti account lo hanno raggiunto, quanti entro 24 ore dalla registrazione e il tempo mediano dal passo precedente.",
  "Period: 7 days": "Periodo: 7 giorni",
  "Period: 30 days": "Periodo: 30 giorni",
  "Period: 90 days": "Periodo: 90 giorni",
  "Step": "Passo",
  "Accounts": "Account",
  "Of sign-ups": "Sulle registrazioni",
  "Within 24 hours": "Entro 24 ore",
  "Median time from previous step": "Mediana dal passo precedente",
  "Registration": "Registrazione",
  "Email confirmed": "Email confermata",
  "Card added": "Carta aggiunta",
  "First campaign": "Prima campagna",
  "Stream with an offer": "Flusso con offerta",
  "First click": "Primo clic",
  "First lead (forms only)": "Primo lead (solo moduli)",
  "First conversion": "Prima conversione",
  "Paid": "Pagato",
  "In trial": "In prova",
  "Stopped: no payment": "Fermato: nessun pagamento",
  "No card": "Nessuna carta",
  "Granted by operator": "Concesso dall’operatore",
  "First conversion within 24 hours of sign-up": "Prima conversione entro 24 ore dalla registrazione",
  "Recent accounts": "Account recenti",
  "Email": "Email",
  "Registered": "Registrato il",
  "Stopped at": "Fermo a",
  "Result": "Esito",
  "All steps done": "Tutti i passi completati",
  "No accounts in this period.": "Nessun account in questo periodo.",
  "Card time is estimated from the trial end date. Email confirmation time is recorded from this release on.": "L’ora della carta è stimata dalla fine della prova. L’ora di conferma dell’email viene registrata da questa versione.",
  "Failed to load the trial funnel": "Impossibile caricare il funnel della prova",
  "{n} min": "{n} min",
  "{n} h": "{n} h",
  "{n} d": "{n} g",
  "{n} of {total} accounts": "{n} su {total} account",
  "Loading…": "Caricamento…",
};

const pl = {
  "Trial: where clients stop": "Okres próbny: gdzie klienci się zatrzymują",
  "Accounts registered in the period, without team members and operator accounts. For each step: how many accounts reached it, how many did it within 24 hours of sign-up, and the median time from the previous step.": "Konta zarejestrowane w okresie, bez członków zespołów i kont operatorów. Dla każdego kroku: ile kont go osiągnęło, ile w ciągu 24 godzin od rejestracji oraz mediana czasu od poprzedniego kroku.",
  "Period: 7 days": "Okres: 7 dni",
  "Period: 30 days": "Okres: 30 dni",
  "Period: 90 days": "Okres: 90 dni",
  "Step": "Krok",
  "Accounts": "Konta",
  "Of sign-ups": "Z rejestracji",
  "Within 24 hours": "W ciągu 24 godz.",
  "Median time from previous step": "Mediana od poprzedniego kroku",
  "Registration": "Rejestracja",
  "Email confirmed": "E-mail potwierdzony",
  "Card added": "Karta dodana",
  "First campaign": "Pierwsza kampania",
  "Stream with an offer": "Strumień z ofertą",
  "First click": "Pierwsze kliknięcie",
  "First lead (forms only)": "Pierwszy lead (tylko formularze)",
  "First conversion": "Pierwsza konwersja",
  "Paid": "Opłacone",
  "In trial": "Okres próbny",
  "Stopped: no payment": "Zatrzymane: brak płatności",
  "No card": "Brak karty",
  "Granted by operator": "Przyznane przez operatora",
  "First conversion within 24 hours of sign-up": "Pierwsza konwersja w ciągu 24 godzin od rejestracji",
  "Recent accounts": "Ostatnie konta",
  "Email": "E-mail",
  "Registered": "Data rejestracji",
  "Stopped at": "Zatrzymał się na",
  "Result": "Wynik",
  "All steps done": "Wszystkie kroki wykonane",
  "No accounts in this period.": "Brak kont w tym okresie.",
  "Card time is estimated from the trial end date. Email confirmation time is recorded from this release on.": "Czas dodania karty jest szacowany na podstawie końca okresu próbnego. Czas potwierdzenia e-maila jest zapisywany od tej wersji.",
  "Failed to load the trial funnel": "Nie udało się wczytać lejka okresu próbnego",
  "{n} min": "{n} min",
  "{n} h": "{n} godz.",
  "{n} d": "{n} dni",
  "{n} of {total} accounts": "{n} z {total} kont",
  "Loading…": "Ładowanie…",
};

const tr = {
  "Trial: where clients stop": "Deneme: müşteriler nerede duruyor",
  "Accounts registered in the period, without team members and operator accounts. For each step: how many accounts reached it, how many did it within 24 hours of sign-up, and the median time from the previous step.": "Dönem içinde kaydolan hesaplar; ekip üyeleri ve operatör hesapları hariç. Her adım için: kaç hesabın ulaştığı, kaçının kayıttan sonraki 24 saat içinde ulaştığı ve önceki adımdan itibaren medyan süre.",
  "Period: 7 days": "Dönem: 7 gün",
  "Period: 30 days": "Dönem: 30 gün",
  "Period: 90 days": "Dönem: 90 gün",
  "Step": "Adım",
  "Accounts": "Hesaplar",
  "Of sign-ups": "Kayıtlara oranı",
  "Within 24 hours": "24 saat içinde",
  "Median time from previous step": "Önceki adımdan medyan süre",
  "Registration": "Kayıt",
  "Email confirmed": "E-posta onaylandı",
  "Card added": "Kart eklendi",
  "First campaign": "İlk kampanya",
  "Stream with an offer": "Teklifli akış",
  "First click": "İlk tıklama",
  "First lead (forms only)": "İlk lead (yalnızca formlar)",
  "First conversion": "İlk dönüşüm",
  "Paid": "Ödendi",
  "In trial": "Denemede",
  "Stopped: no payment": "Durduruldu: ödeme yok",
  "No card": "Kart yok",
  "Granted by operator": "Operatör tarafından verildi",
  "First conversion within 24 hours of sign-up": "Kayıttan sonraki 24 saat içinde ilk dönüşüm",
  "Recent accounts": "Son hesaplar",
  "Email": "E-posta",
  "Registered": "Kayıt tarihi",
  "Stopped at": "Durduğu adım",
  "Result": "Sonuç",
  "All steps done": "Tüm adımlar tamamlandı",
  "No accounts in this period.": "Bu dönemde hesap yok.",
  "Card time is estimated from the trial end date. Email confirmation time is recorded from this release on.": "Kart zamanı deneme bitiş tarihinden tahmin edilir. E-posta onay zamanı bu sürümden itibaren kaydedilir.",
  "Failed to load the trial funnel": "Deneme hunisi yüklenemedi",
  "{n} min": "{n} dk",
  "{n} h": "{n} sa",
  "{n} d": "{n} g",
  "{n} of {total} accounts": "{total} hesaptan {n}",
  "Loading…": "Yükleniyor…",
};

const uk = {
  "Trial: where clients stop": "Пробний період: де клієнти зупиняються",
  "Accounts registered in the period, without team members and operator accounts. For each step: how many accounts reached it, how many did it within 24 hours of sign-up, and the median time from the previous step.": "Акаунти, зареєстровані за період, без учасників команд і акаунтів операторів. Для кожного кроку: скільки акаунтів його пройшли, скільки — за перші 24 години після реєстрації, і медіанний час від попереднього кроку.",
  "Period: 7 days": "Період: 7 днів",
  "Period: 30 days": "Період: 30 днів",
  "Period: 90 days": "Період: 90 днів",
  "Step": "Крок",
  "Accounts": "Акаунти",
  "Of sign-ups": "Від реєстрацій",
  "Within 24 hours": "За 24 години",
  "Median time from previous step": "Медіана від попереднього кроку",
  "Registration": "Реєстрація",
  "Email confirmed": "Адресу підтверджено",
  "Card added": "Картку додано",
  "First campaign": "Перша кампанія",
  "Stream with an offer": "Потік з офером",
  "First click": "Перший клік",
  "First lead (forms only)": "Перший лід (лише форми)",
  "First conversion": "Перша конверсія",
  "Paid": "Оплачено",
  "In trial": "Пробний період",
  "Stopped: no payment": "Зупинено: немає оплати",
  "No card": "Немає картки",
  "Granted by operator": "Видано оператором",
  "First conversion within 24 hours of sign-up": "Перша конверсія за перші 24 години після реєстрації",
  "Recent accounts": "Останні акаунти",
  "Email": "Ел. пошта",
  "Registered": "Дата реєстрації",
  "Stopped at": "Зупинився на кроці",
  "Result": "Підсумок",
  "All steps done": "Усі кроки пройдено",
  "No accounts in this period.": "За цей період акаунтів немає.",
  "Card time is estimated from the trial end date. Email confirmation time is recorded from this release on.": "Час додавання картки розраховано за датою закінчення пробного періоду. Час підтвердження адреси записується починаючи з цієї версії.",
  "Failed to load the trial funnel": "Не вдалося завантажити воронку пробного періоду",
  "{n} min": "{n} хв",
  "{n} h": "{n} год",
  "{n} d": "{n} дн.",
  "{n} of {total} accounts": "{n} з {total} акаунтів",
  "Loading…": "Завантаження…",
};

const TRIAL_FUNNEL = { ru, es, pt, de, fr, it, pl, tr, uk };
export default TRIAL_FUNNEL;
